import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logoSiloam from "../../assets/logo_siloam.png";
import bg from "../../assets/bg_sos.jpg";
import imgHeader from "../../assets/header_sos.png";
import PopupAdd from "../../components/popup_add";

const PageContact = () => {
  const navigate = useNavigate();

  return (
    <>
      <div className="relative w-full md:w-[500px] mx-auto h-screen flex flex-col justify-between items-center ">
        <img
          src={bg}
          className="absolute z-10 w-full h-full mx-auto object-cover"
          alt=""
        />

        <img
          src={imgHeader}
          className="absolute z-50 top-0 w-full object-contain mx-auto object-cover"
          alt=""
        />

        <div className="overflow-x-hidden z-10 relative flex flex-grow w-full h-auto justify-center items-center  px-5">
          <div className="flex flex-col justify-center items-center pb-20 w-full space-y-6">
            <div className=" text-white text-center font-bold text-2xl uppercase">
              <div className="mb-4">CONTACT US</div>
            </div>

            <a
              href="https://wa.me/6281290315031"
              target="_blank"
              rel="noreferrer"
            >
              <button className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-[#fbda08]  font-bold">
                CONTACT 1
              </button>
            </a>

            <a
              href="https://wa.me/6281298830128 "
              target="_blank"
              rel="noreferrer"
            >
              <button className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-[#fbda08]  font-bold">
                CONTACT 2
              </button>
            </a>

            <a
              href="https://wa.me/628988008968 "
              target="_blank"
              rel="noreferrer"
            >
              <button className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-[#fbda08]  font-bold">
                CONTACT 3
              </button>
            </a>

            <a
              href="https://wa.me/6281373337278"
              target="_blank"
              rel="noreferrer"
            >
              <button className="min-w-[240px] px-1 py-2 bg-transparent border-2 border-[#fbda08] rounded-lg text-[#fbda08]  font-bold">
                CONTACT 4
              </button>
            </a>

            <button
              onClick={() => navigate("/")}
              className="min-w-[240px] px-5 py-2 bg-transprent border-2 border-red-500 rounded-lg text-white font-bold"
            >
              BACK
            </button>
          </div>
        </div>

       
      </div>
    </>
  );
};

export default PageContact;
